import { gql } from '@apollo/client'
import { workOrderDocumentFragment } from './graphql'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { LinkWorkOrderTaskArgs, WorkOrder } from '@ztechapps/common.contract'

export const linkWorkOrderTaskQuery = gql`
  mutation linkWorkOrderTask($input: LinkWorkOrderTaskArgs!) {
    linkWorkOrderTask(input: $input) {
      ...workOrderDocumentFragment
    }
  }
  ${workOrderDocumentFragment}
`

export const useLinkProjectTask = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, LinkWorkOrderTaskArgs> => {
  query = query ?? linkWorkOrderTaskQuery

  return useActionMutation({
    query,
    ...props,
  })
}
